import { Schedule, HotelArea } from "./types";

export const BASE_URL = process.env.REACT_APP_BASE_URL;
export const API_URL = process.env.REACT_APP_API_URL;
export const JID_URL = process.env.REACT_APP_JID_URL;
export const JID_ACCOUNT_URL = process.env.REACT_APP_JID_ACCOUNT_URL;
export const COOKIE_EID = process.env.REACT_APP_COOKIE_EID || "eid";

export const schedules: Schedule[] = [
    {
      id: "day",
      label: "日帰り",
    },
    {
      id: "stay",
      label: "宿泊",
    },
];

export const regions = [
    {
        prior: 0,
        region_id: "unselected",
        label: "選んでください",
    },
    {
        prior: 1,
        region_id: "tokyo",
        label: "東京",
    },
    {
        prior: 2,
        region_id: "osaka",
        label: "大阪",
    },
    {
        prior: 3,
        region_id: "fukuoka",
        label: "福岡",
    },
    {
        prior: 4,
        region_id: "sapporo",
        label: "札幌",
    },
    {
        prior: 5,
        region_id: "naha",
        label: "那覇",
    },
    {
        prior: 99,
        region_id: 'others',
        label: "その他",
    }
];

export const regionTokyoEast = [
    {
        prior: 0,
        region_id: "unselected",
        label: "選んでください",
    },
    {
        prior: 1,
        region_id: "tokyo",
        label: "東京",
    },
    {
        prior: 99,
        region_id: "ueno",
        label: "上野",
    },
    {
        prior: 99,
        region_id: "ohmiya",
        label: "大宮",
    },
    {
        prior: 99,
        region_id: 'others',
        label: "その他",
    }
];

export const regionTokyoCentral = [
    {
        prior: 0,
        region_id: "unselected",
        label: "選んでください",
    },
    {
        prior: 1,
        region_id: "tokyo",
        label: "東京",
    },
    {
        prior: 99,
        region_id: "shinagawa",
        label: "品川",
    },
    {
        prior: 99,
        region_id: 'others',
        label: "その他",
    }
];

export const regionTohoku = [
    {
        prior: 0,
        region_id: "unselected",
        label: "選んでください",
    },
    {
        prior: 99,
        region_id: "sendai",
        label: "仙台",
    },
    {
        prior: 99,
        region_id: "aizuwakamatsu",
        label: "会津若松",
    },
    {
        prior: 99,
        region_id: "yamagata",
        label: "山形",
    },
    {
        prior: 99,
        region_id: "tendo",
        label: "天童",
    },
    {
        prior: 99,
        region_id: 'others',
        label: "その他",
    }
];

export const regionHokuriku = [
    {
        prior: 0,
        region_id: "unselected",
        label: "選んでください",
    },
    {
        prior: 99,
        region_id: "toyama",
        label: "富山",
    },
    {
        prior: 99,
        region_id: "kanazawa",
        label: "金沢",
    },
    {
        prior: 99,
        region_id: 'others',
        label: "その他",
    }
];

export const regionShinshu = [
    {
        prior: 0,
        region_id: "unselected",
        label: "選んでください",
    },
    {
        prior: 99,
        region_id: "karuizawa",
        label: "軽井沢",
    },
    {
        prior: 99,
        region_id: "nagano",
        label: "長野",
    },
    {
        prior: 99,
        region_id: 'others',
        label: "その他",
    }
];

export const regionChubu = [
    {
        prior: 0,
        region_id: "unselected",
        label: "選んでください",
    },
    {
        prior: 99,
        region_id: "toyohashi",
        label: "豊橋",
    },
    {
        prior: 99,
        region_id: "nagoya",
        label: "名古屋",
    },
    {
        prior: 99,
        region_id: 'others',
        label: "その他",
    }
];

export const regionKansai = [
    {
        prior: 0,
        region_id: "unselected",
        label: "選んでください",
    },
    {
        prior: 99,
        region_id: "shin-osaka",
        label: "新大阪",
    },
    {
        prior: 99,
        region_id: "kyoto",
        label: "京都",
    },
    {
        prior: 99,
        region_id: "shinkobe",
        label: "新神戸",
    },
    {
        prior: 99,
        region_id: 'others',
        label: "その他",
    }
];

export const regionTokyo = [
    {
        prior: 0,
        region_id: "unselected",
        label: "選んでください",
    },
    {
        prior: 1,
        region_id: "tokyo",
        label: "東京",
    },
    {
        prior: 99,
        region_id: 'others',
        label: "その他",
    }
];

export const regionShinyoko = [
    {
        prior: 0,
        region_id: "unselected",
        label: "選んでください",
    },
    {
        prior: 99,
        region_id: "shin-yokohama",
        label: "新横浜",
    },
    {
        prior: 99,
        region_id: 'others',
        label: "その他",
    }
];

export const regionUeno = [
    {
        prior: 0,
        region_id: "unselected",
        label: "選んでください",
    },
    {
        prior: 99,
        region_id: "ueno",
        label: "上野",
    },
    {
        prior: 99,
        region_id: 'others',
        label: "その他",
    }
];

export const regionOmiya = [
    {
        prior: 0,
        region_id: "unselected",
        label: "選んでください",
    },
    {
        prior: 99,
        region_id: "omiya",
        label: "大宮",
    },
    {
        prior: 99,
        region_id: 'others',
        label: "その他",
    }
];

export const regionFdatravel = [
  {
    prior: 11,
    region_id: "fdatravel_region",
    label: "",
  },
];

export const ranks = [
  {
    id: "economy",
    label: "エコノミー",
  },
  {
    id: "standard",
    label: "スタンダード",
  },
  {
    id: "superior",
    label: "スーペリア",
  },
  {
    id: "deluxe",
    label: "デラックス",
  },
];

export const transports = [
  {
    id: "train",
    label: "新幹線・特急",
  },
  {
    id: "air",
    label: "飛行機",
  },
  {
    id: "notransports",
    label: "宿泊のみ",
  },
];

export const outwardTimesForTrain = [
    {
        id: "first_train",
        label: "始発",
        time: "始発便〜8時発",
        since: "",
        until: "08:00:00",
      },
      {
        id: "morning",
        label: "朝",
        time: "8時〜10時発",
        since: "08:00:00",
        until: "10:00:00",
      },
      {
        id: "noon",
        label: "昼前",
        time: "10時以降〜12時発",
        since: "10:00:00",
        until: "12:00:00",
      },
];

export const returnTimesForTrain = [
    {
        id: "early_afternoon",
        label: "午後早め",
        time: "12時〜14時発",
        since: "12:00:00",
        until: "14:00:00",
      },
      {
        id: "late_afternoon",
        label: "午後遅め",
        time: "14時〜16時発",
        since: "14:00:00",
        until: "16:00:00",
      },
      {
        id: "evening",
        label: "夕方",
        time: "16時〜18時発",
        since: "16:00:00",
        until: "18:00:00",
      },
      {
        id: "early_night",
        label: "夜早め",
        time: "18時〜20時発",
        since: "18:00:00",
        until: "20:00:00",
      },
      {
        id: "late_night",
        label: "夜遅め",
        time: "20時〜22時発",
        since: "20:00:00",
        until: "22:00:00",
      },
      {
        id: "last_train",
        label: "最終",
        time: "22時〜終電",
        since: "22:00:00",
        until: ""
      },
];

export const outwardTimes = [
    {
        id: "first_flight",
        label: "始発",
        time: "始発便〜10時発",
        since: "",
        until: "10:00:00",
    },
    {
        id: "noon",
        label: "昼",
        time: "10時以降〜14時発",
        since: "10:00:00",
        until: "14:00:00",
    },
];

export const returnTimes = [
    {
        id: "evening",
        label: "夕方",
        time: "14時以降〜18時発",
        since: "14:00:00",
        until: "18:00:00",
    },
    {
        id: "night",
        label: "夜",
        time: "18時以降〜最終便",
        since: "18:00:00",
        until: "",
    },
];

export const _departureTimes = [
  {
    id: "first_flight",
    label: "始発",
    time: "始発便〜8時発",
    until: "08:00:00",
  },
  {
    id: "morning",
    label: "朝",
    time: "8時〜10時発",
    since: "08:00:00",
    until: "10:00:00",
  },
  {
    id: "noon",
    label: "昼前",
    time: "10時以降〜12時発",
    since: "10:00:00",
    until: "12:00:00",
  },
  {
    id: "early_afternoon",
    label: "午後早め",
    time: "12時〜14時発",
    since: "12:00:00",
    until: "14:00:00",
  },
  {
    id: "late_afternoon",
    label: "午後遅め",
    time: "14時〜16時発",
    since: "14:00:00",
    until: "16:00:00",
  },
  {
    id: "evening",
    label: "夕方",
    time: "16時〜18時発",
    since: "16:00:00",
    until: "18:00:00",
  },
  {
    id: "early_night",
    label: "夜早め",
    time: "18時〜20時発",
    since: "18:00:00",
    until: "20:00:00",
  },
  {
    id: "late_night",
    label: "夜遅め",
    time: "20時〜22時発",
    since: "20:00:00",
    until: "22:00:00",
  },
  {
    id: "last_flight",
    label: "最終",
    time: "22時〜終電",
    since: "22:00:00",
  },
];


export const departureTimes = [
    {
      id: "morning",
      label: "朝",
      time: "始発便〜10時発",
      until: "10:00:00",
    },
    {
      id: "noon",
      label: "昼",
      time: "10時以降〜14時発",
      since: "10:00:00",
      until: "14:00:00",
    },
    {
      id: "evening",
      label: "夕方",
      time: "14時以降〜18時発",
      since: "14:00:00",
      until: "18:00:00",
    },
    {
      id: "night",
      label: "夜",
      time: "18時以降〜最終便",
      since: "18:00:00",
    },
  ];

export const outwardFDATravelTimes = [
    {
      id: "morning",
      label: "FDA531",
      time: "09:00発~10:50着",
      since: "09:00:00",
      until: "10:50:00",
    },
    {
      id: "noon",
      label: "FDA533",
      time: "14:10発~16:00着",
      since: "14:10:00",
      until: "16:00:00",
    },
    {id:"morning",label:"FDA321",time:"07:00発〜08:25着",since:"07:00:00",until:"08:25:00",},
    {id:"noon",label:"FDA2323",time:"11:05発〜12:35着",since:"11:05:00",until:"12:35:00",},
    {id:"noon",label:"FDA325",time:"12:20発〜13:50着",since:"12:20:00",until:"13:50:00",},
    {id:"evening",label:"FDA2327",time:"15:15発〜16:45着",since:"15:15:00",until:"16:45:00",},
    {id:"evening",label:"FDA327",time:"18:05発〜19:30着",since:"18:05:00",until:"19:30:00",},
    {id:"morning",label:"FDA411",time:"07:20発〜08:20着",since:"07:20:00",until:"08:20:00",},
    {id:"evening",label:"FDA2415",time:"15:05発〜16:05着",since:"15:05:00",until:"16:05:00",},
    {id:"evening",label:"FDA417",time:"16:35発〜17:35着",since:"16:35:00",until:"17:35:00",},
];

export const returnFDATravelTimes = [
    {
      id: "noon",
      label: "FDA532",
      time: "11:20発~13:35着",
      since: "11:20:00",
      until: "13:35:00",
    },
    {
      id: "evening",
      label: "FDA536",
      time: "16:30発~18:45着",
      since: "16:30:00",
      until: "18:45:00",
    },
    {id:"morning",label:"FDA322",time:"09:20発〜10:40着",since:"09:20:00",until:"10:40:00",},
    {id:"morning",label:"FDA2322",time:"10:55発〜12:15着",since:"10:55:00",until:"12:15:00",},
    {id:"noon",label:"FDA2324",time:"13:10発〜14:30着",since:"13:10:00",until:"14:30:00",},
    {id:"noon",label:"FDA326",time:"14:25発〜15:45着",since:"14:25:00",until:"15:45:00",},
    {id:"evening",label:"FDA328",time:"20:00発〜21:20着",since:"20:00:00",until:"21:20:00",},
    {id:"morning",label:"FDA412",time:"08:55発〜09:50着",since:"08:55:00",until:"09:50:00",},
    {id:"evening",label:"FDA241",time:"16:40発〜17:35着",since:"16:40:00",until:"17:35:00",},
    {id:"evening",label:"FDA418",time:"18:10発〜19:05着",since:"18:10:00",until:"19:05:00",},
];

export const locations = [
  {
    id: "nearStation",
    label: "駅近",
  },
  {
    id: "downtown",
    label: "繁華街",
  },
  {
    id: "anywhere",
    label: "こだわらない",
  },
];

export const bathChoice = [
  {
    id: "with",
    label: "あり",
  },

  {
    id: "without",
    label: "こだわらない",
  },
];

export const breakfastChoice = [
  {
    id: "with",
    label: "あり",
  },

  {
    id: "without",
    label: "こだわらない",
  },
];

export const smokingChoice = [
  {
    id: "nonsmoking",
    label: "禁煙",
  },
  {
    id: "smoking",
    label: "喫煙",
  },
  {
    id: "either",
    label: "こだわらない",
  },
];

export const dinnerChoice = [
  {
    id: "advice",
    label: "相談する",
  },
  {
    id: "noadvice",
    label: "相談しない",
  },
];

export function getErrorMessage(error: unknown) {
  if (error instanceof Error) return error.message;
  return String(error);
}

export function classNames(...classes: any) {
  return classes.filter(Boolean).join(" ");
}

export const ERROR_REQUIRED = "必須項目です。";

export const renderError = ({ message }: { message: string }) => (
  <div className="text-red-500 mt-1 font-semibold">{message}</div>
);

export function getDiffDate(date1: Date, date2: Date) {
    const d1 = new Date(date1.getFullYear(), date1.getMonth() + 1, date1.getDate());
    const d2 = new Date(date2.getFullYear(), date2.getMonth() + 1, date2.getDate());

    return Math.floor((d2.getTime() - d1.getTime()) / 86400000);
}

export enum State {
  DEFAULT,
  SCHEDULE,
  DEPARTURE_FLIGHT,
  RETURN_FLIGHT,
  HOTEL,
  OPTION,
  TRANSPORT,
}

export const getData = async (region_id: string): Promise<HotelArea[]> => {
    try {
        const response = await fetch(`${API_URL}/hotelareas?` + new URLSearchParams({ region_id: region_id }),
            {
                method: "GET" 
            });
        
        if (!response.ok) {
            throw new Error(
                `This is an HTTP error: The status is ${response.status}`
            );
        }

        const actualData = await response.json();
        const areas = actualData.hotelarea;

        return areas;
    } catch (err) {
        return [];
    }
};